export default __webpack_public_path__ + "static/Wizard_02-1c2ea1f11d4bbd7f33f307a449837e9e.webp";